import { render } from "./SimpleProgram.vue?vue&type=template&id=94243bbc"
import script from "./SimpleProgram.vue?vue&type=script&lang=js"
export * from "./SimpleProgram.vue?vue&type=script&lang=js"

import "./SimpleProgram.vue?vue&type=style&index=0&id=94243bbc&lang=css"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__